import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import * as Service from '../services';
import { addAfterLoginNotification } from '../../../components/Toast/utils/notifications';


interface AsyncState {
  isLoading: {
    categoryDetails: boolean;
    categoryEdit: boolean;
  };
  isSuccess: boolean;
  isError: boolean;
}

interface TableState extends AsyncState {
  categoryDetails: any;
  statusData: any;
  editCategoryRes: any;
  isLogout: any;
  fullResponse: Array<any>;
  rootReducer?: any;
  auth?: any;
  errorMsg?: any;

}

const initialState: TableState = {
  isLoading: {
    categoryDetails: true,
    categoryEdit: false,
  },
  isSuccess: false,
  isError: false,
  categoryDetails: null,
  statusData: null,
  editCategoryRes: null,
  isLogout: false,
  fullResponse: [],
  errorMsg: null,
};



// Fetch single product by ID
export const fetchCategoryById = createAsyncThunk(
  "products/fetchCategoryById",
  async (id: any, thunkAPI) => {
    try {
      return await Service.getOneCategory(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);


export const editCategory = createAsyncThunk('editCategoryData', async (data: any, thunkAPI) => {
  try {
    return await Service.editCategory(data);
  } catch (error) {
    // thunkAPI.dispatch(resetLogout(error));
    return thunkAPI.rejectWithValue(error);
  }
});



export const categoryDetailsSlice = createSlice({
  name: 'category details',
  initialState,
  reducers: {
    reset: (state) => {
      state.isLoading.categoryDetails = false;
      state.isSuccess = false;
      state.isError = false;
      state.categoryDetails = initialState.categoryDetails;
    },
  },
  extraReducers: (builder) => {
    builder
      //Obtaining data
      .addCase(fetchCategoryById.pending, (state, action: any) => {
        state.isLoading.categoryDetails = true;
        state.isError = false;
        state.errorMsg = null;
        state.categoryDetails = null;
      })
      .addCase(fetchCategoryById.fulfilled, (state, action: any) => {
        // console.log('action.payload', action.payload)
        state.isLoading.categoryDetails = false;
        state.isSuccess = true;
        state.isError = false;
        state.categoryDetails = action.payload.data;
        state.errorMsg = null;
      })
      .addCase(fetchCategoryById.rejected, (state) => {
        state.isLoading.categoryDetails = false;
        state.isError = true;
        state.categoryDetails = null;

      })

      .addCase(editCategory.pending, (state) => {
        state.isLoading.categoryEdit = true;
        state.isSuccess = false;
        state.isError = false;
        state.errorMsg = null;
        state.editCategoryRes = null;
      })
      .addCase(editCategory.fulfilled, (state, action: any) => {
        addAfterLoginNotification('Category Updated successfully', "success");
        state.isLoading.categoryEdit = false;
        state.isSuccess = true;
        state.isError = false;
        state.editCategoryRes = action.payload;
      })
      .addCase(editCategory.rejected, (state, action: any) => {
        addAfterLoginNotification(action.payload.errorMsg, "error");
        state.isLoading.categoryEdit = false;
        state.isSuccess = false;
        state.isError = true;
        state.editCategoryRes = null;
        state.errorMsg = action.payload.errorMsg;
      })


  },
});

export const { reset } = categoryDetailsSlice.actions;


export default categoryDetailsSlice.reducer;
